const valuationPageConfig = {
  badge: "Free Valuation",
  title: "Used Car Valuation",
  subtitle: "Get an instant price estimate for your vehicle based on real market listings",
  selectMessages: {
    default: "Select {label}",
    selectBrandFirst: "Select Brand First",
  },
  actions: {
    submitLabel: "Get Valuation",
    submittingLabel: "Calculating...",
  },
  validation: {
    requiredMessage: "Please fill in all required fields",
    failedTitle: "Validation Failed",
    fieldRequired: "{label} is required",
    minValue: "{label} must be at least {min}",
    maxValue: "{label} must be at most {max}",
    errorTitle: "Valuation failed",
    errorMessage: "Could not calculate estimate. Please try again.",
  },
  result: {
    title: "Your Estimated Price",
    rangeLabel: "Expected price range",
    estimateLabel: "Best estimate",
    confidenceLabels: {
      high: "High confidence — based on many similar listings",
      medium: "Moderate confidence — limited comparable listings",
      low: "Low confidence — estimated from broader market data",
    },
    sampleLabel: "Based on {count} similar listings in our marketplace",
    noSampleLabel: "Estimated using market averages for this brand",
    currencySymbol: "₹",
    resetLabel: "Check Another Car",
    sellCtaLabel: "Sell at This Price",
    sellCtaPath: "/upload-car",
    browseCtaLabel: "Browse Similar Cars",
    browseCtaPath: "/cars",
  },
  engine: {
    depreciationPerYear: 0.08,
    kmPenaltyPer1000: 500,
    tireWearFactor: 0.002,
    defaultBasePrice: 500000,
    minPriceFloor: 50000,
    priceVariance: 0.1,
    minSampleSize: 1,
    highConfidenceSample: 5,
    mediumConfidenceSample: 2,
    currency: "INR",
  },
  highlights: [
    {
      id: 1,
      icon: "⚡",
      title: "Instant Estimate",
      description: "Get a price range in seconds from live listing data",
    },
    {
      id: 2,
      icon: "📈",
      title: "Market-Based Pricing",
      description: "Powered by real cars listed on CarsInfinite",
    },
    {
      id: 3,
      icon: "🔒",
      title: "No Obligation",
      description: "Check your car's value before you decide to sell",
    },
  ],
};

export default valuationPageConfig;
